import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  DashboardFilled,
  SettingOutlined,
  LogoutOutlined,
  FileTextOutlined,
  BellTwoTone,
  FileSearchOutlined,
  CustomerServiceOutlined,
  UserOutlined,
  BookOutlined,
  FileDoneOutlined,
  EditOutlined,
  AreaChartOutlined,
  LineChartOutlined,
  BulbFilled,
  BulbOutlined,
} from "@ant-design/icons";
import { Layout, Menu, theme, Space, Dropdown, message, Switch, Tooltip } from "antd";
import React, { useState, useEffect, useMemo, useRef } from "react";
import { Outlet, Link, useLocation, useNavigate } from "react-router-dom";
import { logout } from "../../components/messages/ResponseMessages";
import { capitalizeAndRemoveUnderscores } from '../../utils/utils'
import { onChangeCollapsed } from '../../app/slice/globalData.js'
import { useDispatch, useSelector } from "react-redux";
import useAuthSync from "../../utils/hook/useAuthSync.js";
import Notification from "./Notification.jsx";
import { fetchAllNotifications } from "../../app/slice/chatSlice.js";
import logo from '../../assets/images/coreventum_logo.png';
import Darklogo from '../../assets/images/CoreVentum_logo_dark.png';
import axiosInstance from "../../utils/axiosInstance.js";
import { setAccessGranted } from "../../app/slice/authSlice.js";
import { useTheme } from "../../utils/themeToggle/theme.jsx";

const { Header, Sider, Content } = Layout;
function getItem(label, key, icon, children, type) {
  return {
    key,
    icon,
    children,
    label,
    type,
  };
}

const AntSidebar = () => {
  const [open, setOpen] = useState(false);
  const [accessCode, setAccessCode] = useState("");
  const select = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const userRole = select.userInfo.role;
  const userName = select.userInfo.name;
  const userEmail = select.userInfo.user_email;
  const { logout: logOuted } = useAuthSync();
  const notifications = useSelector((state) => state.chat.allNotification);
  const user_id = useSelector((store) => store.auth.userInfo.user_id);
  const company_id = useSelector((store) => store.auth.userInfo.company_id);
  const notificationRef = useRef(null);
  const bellRef = useRef(null);
  const navigate = useNavigate();
  const accessGranted = select?.userInfo?.is_access_granted;
  const user_type = select?.userInfo?.user_type;
  const isProfessional = user_type === "professional";
  const isLocationProfressional = useLocation().pathname.includes("professional");
  const companyId = Number(localStorage.getItem('companyId'));
  const { darkMode, toggleTheme } = useTheme();


  const handleSubmitAccessCode = async () => {
    try {
      const res = await axiosInstance.post("/company/verify-access-code/", {
        company_id: company_id,
        entered_code: accessCode,
      });
      dispatch(setAccessGranted(true));
      const msg = res?.data?.message || "Access granted.";
      message.success(msg);
    } catch (error) {
      console.error("Error during sending code:", error);
      const errorMsg = error?.response?.data?.error || "Something went wrong. Try again.";
      message.error(errorMsg);
    }
  };

  const handleLogout = () => {
    logOuted()
    navigate("/auth/login");
    logout("Logged-out Successfully.");
  };

  const buildPath = (subPath) => {
    if (isProfessional) {

      return `/admin/company/${companyId}/${subPath}`;
    }
    return `/admin/${subPath}`;
  };


  useEffect(() => {
    dispatch(fetchAllNotifications({ user_id, company_id: companyId || company_id }));
  }, [])

  const superAdminMenu = [
    getItem(<Link to={buildPath("dashboard")}>Dashboard</Link>, buildPath("dashboard"), <DashboardFilled />),
    getItem(<Link to={buildPath("contracts")}>Contracts</Link>, buildPath("contracts"), <BookOutlined />),
    getItem(<Link to={buildPath("analytics")}>Analytics</Link>, buildPath("analytics"), <AreaChartOutlined />),
    getItem(<Link to={buildPath("template")}>Templates</Link>, buildPath("template"), <FileTextOutlined />),
    getItem(<Link to={buildPath("clause")}>Clause</Link>, buildPath("clause"), <FileDoneOutlined />),
    getItem(<Link to={buildPath("settings")}>Settings</Link>, buildPath("settings"), <SettingOutlined />),
  ];


  const adminMenu = [
    getItem(<Link to={buildPath("dashboard")}>Dashboard</Link>, buildPath("dashboard"), <DashboardFilled />),
    getItem(<Link to={buildPath("contracts")}>Contracts</Link>, buildPath("contracts"), <BookOutlined />),
    getItem(<Link to={buildPath("analytics")}>Analytics</Link>, buildPath("analytics"), <AreaChartOutlined />),
    getItem(<Link to={buildPath("esign")}>Esign</Link>, buildPath("esign"), <EditOutlined />),
    getItem(<Link to={buildPath("settings")}>Settings</Link>, buildPath("settings"), <SettingOutlined />),
  ];

  const othersMenu = [
    getItem(<Link to={buildPath("dashboard")}>Dashboard</Link>, buildPath("dashboard"), <DashboardFilled />),
    getItem(<Link to={buildPath("contracts")}>Contracts</Link>, buildPath("contracts"), <BookOutlined />),
    getItem(<Link to={buildPath("analytics")}>Analytics</Link>, buildPath("analytics"), <AreaChartOutlined />),
    getItem(<Link to={buildPath("esign")}>Esign</Link>, buildPath("esign"), <EditOutlined />),
    getItem(<Link to={buildPath("settings")}>Settings</Link>, buildPath("settings"), <SettingOutlined />),
  ];


  const legalMenu = [
    getItem(<Link to={buildPath("dashboard")}>Dashboard</Link>, buildPath("dashboard"), <DashboardFilled />),
    getItem(<Link to={buildPath("contracts")}>Contracts</Link>, buildPath("contracts"), <BookOutlined />),
    getItem(<Link to={buildPath("analytics")}>Analytics</Link>, buildPath("analytics"), <AreaChartOutlined />),
    getItem(<Link to={buildPath("esign")}>Esign</Link>, buildPath("esign"), <EditOutlined />),
    getItem(<Link to={buildPath("template")}>Templates</Link>, buildPath("template"), <FileTextOutlined />),
    getItem(<Link to={buildPath("clause")}>Clause</Link>, buildPath("clause"), <FileDoneOutlined />),
    getItem(<Link to={buildPath("settings")}>Settings</Link>, buildPath("settings"), <SettingOutlined />),
  ];

  const items = useMemo(() => {
    const baseItems = [
      {
        label: (
          <div className="cursor-auto">
            <span className="font-bold">Signed in as</span> <br />
            <h1>{userEmail && userEmail}</h1>
          </div>
        ),
        key: "0",
      },
      {
        type: "divider",
      },
      {
        label: (
          <div className="cursor-auto">
            <h3 className="flex items-center cursor-auto">
              <UserOutlined className="mr-2" /> Role : {userRole ? capitalizeAndRemoveUnderscores(userRole) : ''}
            </h3>
          </div>
        ),
        key: "1",
      },
      {
        type: "divider",
      },
    ];

    // Conditionally add support link only if not superadmin
    if (
      userRole !== "superadmin" &&
      userRole !== "support" &&
      (!isProfessional || !isLocationProfressional)
    ) {
      baseItems.push(
        {
          label: (
            <Link className="flex items-center" to="/admin/support">
              <h3 className="flex items-center">
                <CustomerServiceOutlined className="mr-2" /> Support
              </h3>
            </Link>
          ),
          key: "3",
        },
        {
          type: "divider",
        }
      );
    }

    // Always add signout
    baseItems.push({
      label: (
        <Link onClick={handleLogout} className="flex items-center" to="/auth/login">
          <LogoutOutlined className="mr-2" /> <span>Signout</span>
        </Link>
      ),
      key: "4",
    });

    return baseItems;
  }, [userEmail, userRole, handleLogout]);

  const isCollapsed = useSelector((state) => state.globalDataSlice.isCollapsed);
  const location = useLocation();
  const [selectedKey, setSelectedKey] = useState("");

  useEffect(() => {
    let menuList = [];
    const role = userRole?.toLowerCase().trim();
    console.log(role, "roleuserRoleuserRole");
    if (role === "admin") {
      menuList = adminMenu;
    } else if (role === "superadmin") {
      menuList = superAdminMenu;
    } else if (
      role === "agreement controller head" ||
      role === "agreement controller team" ||
      role === "professional" || role === "professional agreement controller team" || role === "professional agreement controller head"
    ) {
      menuList = legalMenu;
    } else {
      menuList = othersMenu;
    }

    // Make current path clean by removing query params
    const currentPath = location.pathname;

    const matchedItem = menuList.find((item) =>
      currentPath.startsWith(item.key)
    );

    if (matchedItem) {
      setSelectedKey(matchedItem.key);
      console.log(matchedItem, "matchedItem.keymatchedItem.key", selectedKey);;
    } else {
      // Try fallback logic: for deeply nested routes like "/admin/contracts/155"
      if (currentPath.startsWith("/admin/contracts")) {
        setSelectedKey(buildPath("contracts"));
      } else if (currentPath.startsWith("/admin/analytics")) {
        setSelectedKey(buildPath("analytics"));
      } else if (currentPath.startsWith("/admin/dashboard")) {
        setSelectedKey(buildPath("dashboard"));
      } else if (currentPath.startsWith("/admin/template")) {
        setSelectedKey(buildPath("template"));
      } else if (currentPath.startsWith("/admin/clause")) {
        setSelectedKey(buildPath("clause"));
      } else if (currentPath.startsWith("/admin/settings")) {
        setSelectedKey(buildPath("settings"));
      } else {
        setSelectedKey("");
      }
    }
  }, [location.pathname, userRole]);


  const isDashboardPage = /\/admin\/(?:company\/\d+\/)?dashboard(?:\/|$)/.test(location.pathname);

  const {
    token: { colorBgContainer },
  } = theme.useToken();

  let componentToRender;
  if (userRole && userRole.toLowerCase() === "admin") {
    componentToRender = (
      <Menu
        style={{ background: "#122253", color: "#CCEBFF" }}
        mode="inline"
        items={adminMenu}
        selectedKeys={[selectedKey]}
        className="mt-4"
      ></Menu>
    );
  } else if (userRole && userRole.toLowerCase() === "superadmin") {
    componentToRender = (
      <Menu
        style={{ background: "#122253", color: "#CCEBFF" }}
        mode="inline"
        items={superAdminMenu}
        selectedKeys={[selectedKey]}
        className="mt-4"
      ></Menu>
    );
  } else if (
    userRole &&
    [
      "agreement controller head",
      "agreement controller team",
      "professional",
      "professional agreement controller team",
      "professional agreement controller head"
    ].includes(userRole.toLowerCase())) {
    componentToRender = (
      <Menu
        style={{ background: "#122253", color: "#CCEBFF" }}
        mode="inline"
        items={legalMenu}
        selectedKeys={[selectedKey]}
        className="mt-4"
      ></Menu>
    );
  } else {
    componentToRender = (
      <Menu
        style={{ background: "#122253", color: "#CCEBFF" }}
        mode="inline"
        items={othersMenu}
        selectedKeys={[selectedKey]}
        className="mt-4"
      ></Menu>
    );
  }

  // Function to get initials from a name
  const getInitials = (name) => {
    if (!name) {
      window.location.href = "/auth/login";
      return null;
    }
    const parts = name && name.split(" ");
    return parts.map((part) => part[0]).join("");
  };

  // Calculate initials from the name
  const initials = getInitials(userName);
  const rounderStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "50%",
    backgroundColor: "#A395DA",
    color: "#fff",
    padding: "0.5rem",
    width: "3rem",
    height: "3rem",
    maxWidth: "none",
    maxHeight: "none",
  };

  const onCloseNotification = () => {
    setOpen(false)
  }

  const onNotificationOpen = () => {
    setOpen(!open);
    if (!open) {
      dispatch(fetchAllNotifications({ user_id, company_id: companyId || company_id }));
    }

  }

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        notificationRef.current &&
        !notificationRef.current.contains(event.target) &&
        bellRef.current &&
        !bellRef.current.contains(event.target)
      ) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="wrapper-scale " style={{ transform: "scale(0.9)", transformOrigin: "top left", width: "111%", height: "100vh" }}>
      <Layout className="flex  ant-layout" style={{ minHeight: "111vh", backgroundColor: darkMode ? "#0E0E2C" : "#EBE8F7" }}>
        <Header className="fixed-header px-2 bg-violet-100 dark:bg-[#17153B] h-[75px] flex justify-between flex-row border-b-[1px] border-[#cdcccc] dark:border-gray-600 z-50"
        >
          <div className="flex justify-start flex-row">
            <div className="demo-logo-vertical">
              <div className="text-center mb-[20px] text-[40px] font-bold flex flex-col">

                {
                  darkMode ?
                    <img src={Darklogo} alt="CoreVentum Logo" className="h-20 pt-2 pb-2" /> :
                    <img src={logo} alt="CoreVentum Logo" className="h-20 pt-2 pb-4 pl-2" />
                }
              </div>
            </div>
            {(!isProfessional || !isLocationProfressional) &&
              <button className="text-[20px] md:text-[25px] ml-8" onClick={() => { dispatch(onChangeCollapsed(!isCollapsed)) }}>
                {isCollapsed ? <MenuUnfoldOutlined size="small" /> : <MenuFoldOutlined size="small" />}
              </button >
            }
          </div>
          <div className="flex items-center justify-between gap-3">
            {(!isProfessional || !isLocationProfressional) &&
              <button ref={bellRef} onClick={() => { onNotificationOpen() }} className="relative mt-4 ">
                <BellTwoTone className="text-3xl" />
                <span className="absolute top-0 right-0 -mr-1 flex h-5 w-5 items-center justify-center rounded-full bg-red-500 text-[10px] text-white">
                  {notifications.length}
                </span>
              </button>
            }
            <div className="flex justify-center items-center">
              <Tooltip title={darkMode ? "Switch to Light" : "Switch to Dark"}>
                <Switch
                  checked={darkMode}
                  onChange={toggleTheme}
                  checkedChildren={<BulbFilled />}
                  unCheckedChildren={<BulbOutlined />}
                  className="transition-all duration-300"
                  style={{
                    backgroundColor: darkMode ? "#122253" : "#A395DA",
                  }}
                />
              </Tooltip>
            </div>

            <Dropdown
              menu={{
                items,
              }}
            >
              <a onClick={(e) => e.preventDefault()}>
                <Space>
                  <div style={rounderStyle}>{initials}</div>
                  <span className=" dark:text-white font-semibold text-md mr-5">
                    {userName && userName}
                  </span>
                </Space>
              </a>
            </Dropdown>
          </div>
          {/* </Space> */}
        </Header>
        <Layout className={`mt-[4rem] h-[100vh] dark:bg-[#0E0E2C] transition-all duration-300 ${open ? "opacity-40 bg-black/40 pointer-events-none	overflow-hidden" : "bg-[#EBE8F7] opacity-100"}`}
        // bg-black/20 backdrop-blur-sm 
        >
          {(!isProfessional || !isLocationProfressional) && (
            <Sider
              trigger={null}
              collapsible
              collapsed={isCollapsed}
              style={{
                marginTop: "24px",
                borderRadius: "0 1rem 0 0",
                position: "fixed",
                left: 0,
                height: "111vh",
                zIndex: 1000,
                backgroundColor: "#122253",
              }}
            >
              <div className="h-full relative flex flex-col justify-between">

                {componentToRender}

                {["professional", "professional agreement controller team", "professional agreement controller head"].includes(userRole) && <div
                  onClick={() => navigate("/admin/company/professional")}
                  className="absolute bottom-20 right-3 gap-3 px-3 py-3 mb-3 mx-1 cursor-pointer rounded-md border border-white bg-[#122253] hover:bg-[#17153B] transition-all duration-300 text-white"
                >
                  <LineChartOutlined className="text-white" />

                  <span
                    className={`
                    text-[13px] font-semibold whitespace-nowrap
                    transition-all duration-500 ease-in-out
                    ${isCollapsed ? "opacity-0 max-w-0 overflow-hidden" : "opacity-100 max-w-[180px]"}
                  `}
                  >
                    Company Dashboard
                  </span>
                </div>}


              </div>
            </Sider>
          )}


          <Content
            style={{
              marginTop: isProfessional && isLocationProfressional ? "" : "24px",
              padding: isDashboardPage ? "0" : "14px",
              // maxHeight: "calc(100vh - 75px)",
              height: "98vh",
              overflowY: "auto",
              background: darkMode ? "#17153B" : "white",
              marginLeft: isProfessional && isLocationProfressional ? "0" : isCollapsed ? "6em" : "15em",
              transition: "margin-left 0.2s",
              borderTopLeftRadius: isProfessional && isLocationProfressional ? "0" : "1rem",
              marginRight: isProfessional && isLocationProfressional ? "" : ".5em",
              position: "relative",
              border: darkMode ? "1px solid #4b5563" : "1px solid #ddd",
            }}
          >
            <div className={`${userRole === "admin" && accessGranted === false ? "pointer-events-none select-none" : ""}`}>
              <Outlet />
            </div>

            {userRole !== "superadmin" && userRole !== "professional agreement controller head" && userRole !== "support" && accessGranted === false && userRole !== "demo" && userRole !== "professional" && (
              <div className="fixed  top-0 left-20 w-full h-full z-50 flex items-center justify-center bg-white/20 backdrop-blur-[.5px]">
                <div className="bg-white dark:bg-[#2a2754] px-8 py-10 rounded-lg shadow-xl border border-gray-300 dark:border-gray-600 text-gray-800 dark:text-white card-access-dashboard">
                  <div className="flex flex-col items-center justify-center space-y-4">
                    <div className="rounded-full bg-purple-100 p-4">
                      <div className="text-6xl text-[#4E36A3] font-bold z-10000">
                        <FileSearchOutlined />
                      </div>
                    </div>
                    <h2 className="text-2xl font-semibold text-gray-800 dark:bg-gray-200">Access Restricted</h2>
                    <p className="text-sm text-gray-600 px-4">
                      {userRole === "admin"
                        ? `Access to your Coreventum CLM Software has been temporarily restricted. 
                        You can access by logging in with the code "FREE15" to activate a Free License 
                        for up to 3 users or 15 contracts.

                        If you’ve already redeemed the Free License or are interested in our Enterprise Solution, 
                        please reach out to us at producthead@coreventum.com or call ‪+91-9810600295‬.`
                        : "Please contact your admin for access."
                      }
                    </p>

                    {userRole === "admin" && <> <input
                      type="text"
                      placeholder="Enter access code"
                      value={accessCode}
                      onChange={(e) => setAccessCode(e.target.value)}
                      className="w-full border border-gray-300 rounded px-4 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-purple-500"
                    />
                      <button onClick={handleSubmitAccessCode} className="w-full mt-2 bg-[#4E36A3] hover:bg-purple-800 text-white py-2 rounded transition duration-200">
                        Submit
                      </button></>}
                  </div>
                </div>
              </div>
            )}
          </Content>
        </Layout>
        {(
          <Sider
            ref={notificationRef}
            trigger={null}
            collapsed={!open}
            width={350}
            collapsedWidth={0}
            theme="light"
            className="rounded mt-6 transition-all duration-300 "
          >
            <div className="mt-6 h-[103vh] demo-logo-vertical py-4 overflow-y-scroll">
              <Notification onClose={onCloseNotification} />
            </div>
          </Sider>
        )}


      </Layout>
    </div>
  );
};
export default React.memo(AntSidebar);
